import { render, staticRenderFns } from "./SettingsTaxGroupForm.vue?vue&type=template&id=5190b414&"
import script from "./SettingsTaxGroupForm.vue?vue&type=script&lang=js&"
export * from "./SettingsTaxGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTaxGroupForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports